import { css } from "@emotion/css";
import {
  CountryCode,
  getCountries,
  getCountryCallingCode,
} from "libphonenumber-js";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Item } from "react-stately";

import * as flags from "./flags";
import { Select } from "../../../deprecated/select/Select";

type PhoneCountriesSelectProps = {
  value: CountryCode;
  onSelectionChange: (country: CountryCode) => void;
  testID?: string;
  labelID?: string;
};

export function PhoneCountriesSelect({
  testID = "phone-number-country-select",
  onSelectionChange,
  value,
  labelID,
}: PhoneCountriesSelectProps) {
  const { i18n } = useTranslation();

  const countries = useMemo(() => {
    const regionNames = new Intl.DisplayNames([i18n.language ?? "en"], {
      type: "region",
    });

    return getCountries()
      .map((countryCode) => ({
        flag: flags[countryCode],
        textValue: countryCode,
        regionName: regionNames.of(countryCode),
        countryCode,
        countryCallingCode: getCountryCallingCode(countryCode),
      }))
      .sort((a, b) => {
        if (!a.regionName || !b.regionName) {
          return 0;
        }

        return a.regionName < b.regionName ? -1 : 1;
      });
  }, [i18n.language]);

  return (
    <Select
      aria-labelledby={labelID}
      backgroundColor="background-accent-neutral-weak"
      selectedKey={value}
      width="unset"
      displayAs={<img src={flags[value]} height="18" width="26" alt="flag" />}
      onSelectionChange={(countryCode) =>
        onSelectionChange(countryCode as CountryCode)
      }
      testID={testID}
    >
      {countries.map(
        ({ countryCode, countryCallingCode, regionName, flag }) => (
          <Item key={countryCode} textValue={regionName}>
            <img
              src={flag}
              height="18"
              width="26"
              className={css({
                marginRight: "var(--space-2)",
              })}
              alt="flag"
            />
            {`${regionName} (+${countryCallingCode})`}
          </Item>
        )
      )}
    </Select>
  );
}
